import { Project } from 'models'
import { ProjectStore, PROJECT_STORE } from 'store'
import { SortDirection } from 'utilities'

export type RelatedMediaSectionProps = {
  [PROJECT_STORE]?: ProjectStore
  relatedMedia: Project[]
  onChange?: (projectsList: Project[]) => void
}

export enum RelatedMediaTableSortProps {
  TITLE = 'title',
  TYPE = 'type',
  TAGS = 'tags',
  GENRE = 'genre',
  STATUS = 'status'
}

export type RelatedMediaTableSorting = {
  sortProp: RelatedMediaTableSortProps,
  sortDirection: SortDirection
}

// export const relatedMediaTableWidths = {
//   title: 33,
//   type: 12,
//   tags: 28,
//   genre: 15,
//   status: 12
// }
export const relatedMediaTableWidths = {
  title: 600,
  type: 200,
  tags: 500,
  genre: 300,
  status: 155
}
